/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospital } from 'app/shared/model/hospital.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IPatientCategory {
  id?: string;
  categoryCode?: string | null;
  description?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  addedByType?: keyof typeof AddedByType | null;
  addedByID?: string | null;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string | null;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<IPatientCategory> = {
  active: false,
};
